import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideAngularModule } from 'lucide-angular';
import { LucideIconData } from 'node_modules/lucide-angular/icons/types';

@Component({
  selector: 'app-new-action-button',
  templateUrl: './new-action-button.component.html',
  styleUrls: ['./new-action-button.component.scss'],
  imports: [MatButtonModule, MatProgressSpinnerModule, LucideAngularModule, MatTooltipModule],
})
export class NewActionButtonComponent {
  readonly text = input<string>();
  readonly selector = input('');
  readonly icon = input<LucideIconData | null>(null);
  readonly themedButton = input('');
  readonly showLoader = input(false);
  readonly isDisabled = input(false);
  readonly fullWidth = input(false);
  readonly fontSize = input<number>();
  readonly fontWeight = input<number>();
  readonly flexStart = input(false);
  readonly height = input<number>();
  readonly width = input<number>();
  readonly tooltipText = input<string>();
  readonly iconSize = input<number>();
  readonly iconOnlySize = input<number>();
  readonly strokeWidth = input(2);
  readonly hoverUnderline = input(false);
  readonly paddingBottom = input<number>();
  readonly testId = input<string>();
  readonly actionCompleted = output<void>();
  protected inProgress = false;
  protected testIdValue = computed(
    () => this.testId() || this.text()?.replace(/ /g, '-').toLowerCase(),
  );
  protected handleClick = () => {
    if (this.isDisabled()) return;
    this.actionCompleted.emit();
  };
}
